import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'landingMozza.PricingSection.title',
    defaultMessage: `Un <underlined>tarif équitable</underlined> ⚖️,<enter></enter> pour vous, comme pour nos professeurs.`,
  },
});
